import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63a0b5f0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=63a0b5f0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=63a0b5f0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0b5f0",
  null
  
)

export default component.exports